import axiosInst from "../../Config";
import { Decrypt_Value, Encrypt_Value } from "../EncryptDecrypt";

const Pat_ID =
  localStorage.getItem("PID") &&
  Decrypt_Value(localStorage.getItem("PID"), "vozoportal");

export const GetAdditionalInfo_Api = async () =>
  await axiosInst.get(`/vozo/patient/get_additonal_info?pid=${Pat_ID}`);

export const UpdateAdditionalInfo_Api = async (payload) => {
  const encryptedData = Encrypt_Value(payload, "vozo");
  return await axiosInst.put(`/vozo/patient/update_additonal_info?pid=${Pat_ID}`, encryptedData);
};
